<template>
    <div name="profile">
        <content1 />
    </div>
</template>

<script>
import Content1 from '@/pages/privacy/history/Profile0204'
export default {
    name: 'profile',
    components: {Content1}
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/privacy/Profile.vue